import { useEffect } from "react";
export const useMessageListener = (embed, eventName, fn, options) => {
    const enabled = !(options === null || options === void 0 ? void 0 : options.disabled);
    useEffect(() => {
        if (embed && enabled) {
            const debug = location.href.includes("FILLOUT_EMBED_DEBUG");
            const listener = (event) => {
                try {
                    if (event.origin === embed.origin &&
                        event.data.embedId === embed.embedId &&
                        event.data.type === eventName) {
                        if (debug) {
                            console.log(["fillout embed MESSAGE", eventName, event.data]);
                        }
                        fn(event.data);
                    }
                }
                catch (err) { }
            };
            if (debug)
                console.log(["fillout embed MOUNT", eventName]);
            window.addEventListener("message", listener);
            return () => {
                if (debug)
                    console.log(["fillout embed UNMOUNT", eventName]);
                window.removeEventListener("message", listener);
            };
        }
    }, [embed, eventName, fn, enabled]);
};
